<div class="capa-status" [ngClass]="statusClass">
  <span>{{ status }}</span>
</div>
